// Initialize keyboard focus detection
import { initKeyboardFocusDetection } from '@/utils/keyboardFocus';
initKeyboardFocusDetection();

tryHydrateReactComponents();

interface Window {
  Components: Record<string, unknown>;
  ReactJsAsyncInit: (() => void) | undefined;
}

async function tryHydrateReactComponents() {
  // Initialise React if there are any React components.
  if (!document.querySelector('react-component')) {
    console.warn(`No React components found to hydrate.`);
    return;
  }

  const [React, ReactDOM, components, { Toaster }] = await Promise.all([
    import(/* webpackChunkName: "react-core" */ 'react'),
    import(/* webpackChunkName: "react-dom" */ 'react-dom/client'),
    import(/* webpackChunkName: "components" */ '@/components'),
    import(/* webpackChunkName: "react-hot-toast" */ 'react-hot-toast'),
  ]);

  let toasterContainer = document.getElementById('react-hot-toast-container');

  if (!toasterContainer) {
    toasterContainer = document.createElement('div');
    toasterContainer.id = 'react-hot-toast-container';
    document.body.appendChild(toasterContainer);

    const toasterRoot = ReactDOM.createRoot(toasterContainer);
    toasterRoot.render(
      React.createElement(Toaster, {
        position: 'top-center',
        toastOptions: {
          duration: 5000,
          style: {
            background: 'var(--color-ui-specific-success)',
            color: 'var(--color-core-white)',
          },
          error: {
            style: {
              background: 'var(--color-ui-specific-error)',
              color: 'var(--color-core-white)',
            },
          },
        },
      }),
    );
  }

  window.React = React.default;
  // @ts-expect-error ReactDOM type mismatch, can be ignored safely.
  window.ReactDOM = ReactDOM;
  window.Components = components.default;

  if ('ReactJsAsyncInit' in window && typeof window.ReactJsAsyncInit === 'function') {
    console.log(`Hydrating React components.`);

    window.ReactJsAsyncInit();
  }
}
